export default __webpack_public_path__ + "static/media/home_icon.ac0edabc.png";